import {Component} from '@angular/core';
import {LoadingService} from "../../services/loading.service";


@Component({
    standalone: false,
    selector: 'spinner',
    styleUrls: ['spinner.component.css'],
    templateUrl: 'spinner.component.html'
})
export class SpinnerComponent {
    loading: Boolean = false;
    state = {
        // 翻訳キー。テンプレートで transloco を通す。
        message: 'shell.please_wait'
    };

    constructor(loadingService: LoadingService) {
        loadingService.isLoading.subscribe((value) => {
            this.loading = value;
        })
    }
}
